import React from 'react'
import { css } from '@emotion/react'
import { colors, font } from 'plume-ui'
import { useEffect } from 'react'

type Props = {
  setIsShow: React.Dispatch<boolean>
  isShow: boolean
  text: string
}

export const Snackbar: React.FC<Props> = (props) => {
  const [timer, setTimer] = React.useState<number | null>(null)
  const cancel = () => {
    props.setIsShow(false)
    clearTimeout(timer || undefined)
  }
  useEffect(() => {
    if (props.isShow) {
      const t = window.setTimeout(() => {
        props.setIsShow(false)
      }, 5000)
      setTimer(t)
    }
  }, [props.isShow])

  return (
    <>
      {props.isShow ? (
        <div
          className="snackbar"
          css={css`
            width: fit-content;
            padding: 12px 8px 12px 24px;
            gap: 8px;
            height: 56px;
            background: rgba(0, 0, 0, 0.85);
            box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.04);
            border-radius: 8px;
            display: flex;
            flex-direction: row;
            align-items: center;
            z-index: 1000;
            position: absolute;
            bottom: 0%;
            left: 40%;
            animation: bound 5s forwards;
            @keyframes bound {
              0% {
                transform: translateY(60px);
              }
              1% {
                transform: translateY(40px);
              }
              2% {
                transform: translateY(20px);
              }
              3% {
                transform: translateY(0px);
              }
              4% {
                transform: translateY(-15px);
              }
              5% {
                transform: translateY(-25px);
              }
              6% {
                transform: translateY(-32px);
              }
              7% {
                transform: translateY(-28px);
              }
              8% {
                transform: translateY(-24px);
              }
              9% {
                transform: translateY(-24px);
              }
              10% {
                transform: translateY(-24px);
              }
              25% {
                transform: translateY(-24px);
              }
              30% {
                transform: translateY(-24px);
              }
              40% {
                transform: translateY(-24px);
              }
              50% {
                transform: translateY(-24px);
              }
              60% {
                transform: translateY(-24px);
              }
              70% {
                transform: translateY(-24px);
              }
              80% {
                transform: translateY(-24px);
              }
              95% {
                transform: translateY(-24px);
              }
              96% {
                transform: translateY(-18px);
              }
              97% {
                transform: translateY(-12px);
              }
              98% {
                transform: translateY(-6px);
              }
              100% {
                transform: translateY(100px);
              }
            }
          `}
        >
          <div
            className="snackbar-message"
            css={css`
              min-width: 280px;
              height: 32px;
              font-size: 14px;
              color: ${colors.white00};
              font-weight: ${font.weight.normal};
              font-size: 14px;
              line-height: 150%;
              letter-spacing: 0.02em;
              display: flex;
              align-items: center;
            `}
          >
            <p>{props.text}</p>
          </div>
          <div
            css={css`
              position: relative;
              cursor: pointer;
              &:hover .hover-circle {
                opacity: 1;
              }
            `}
            onClick={() => {
              cancel()
            }}
          >
            <img
              src="static/images/default/hover_circle.png"
              className="hover-circle"
              alt="hover circle"
              css={css`
                opacity: 0;
                display: flex;
                align-items: center;
              `}
            />
            <div
              css={css`
                display: flex;
                position: absolute;
                top: 35%;
                left: 35%;
              `}
            >
              <img
                src="static/images/default/close.svg"
                alt="close icon"
                css={css`
                  width: 10px;
                  height: 10px;
                `}
              />
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  )
}
